// LocalStorage helpers to remember host/guest identity per session.
export function setHost(code, hostId, hostName) {
  localStorage.setItem(`sb-host-${code}`, JSON.stringify({ hostId, hostName }));
}
export function getHost(code) {
  try {
    return JSON.parse(localStorage.getItem(`sb-host-${code}`));
  } catch {
    return null;
  }
}
export function setGuest(code, guestId, name) {
  localStorage.setItem(`sb-guest-${code}`, JSON.stringify({ guestId, name }));
}
export function getGuest(code) {
  try {
    return JSON.parse(localStorage.getItem(`sb-guest-${code}`));
  } catch {
    return null;
  }
}
